import {
    Component,
    OnInit,
    ElementRef,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    Renderer2,
    AfterViewInit,
    OnChanges,
    SimpleChanges,
    OnDestroy,
} from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { translationHelper } from '~/helpers/translation.helper';
import { uiHelper } from '~/helpers/ui.helper';
import { sportsTypesChangeListener, SPORTS_TYPE } from '~/constant/sports.constant';

declare let $;

@Component({
    selector: 'DropdownMenu',
    templateUrl: './dropdown.menu.html',
})
export class DropdownMenu implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    isOpen = false;

    @Input() _DATA;
    @Input() componentWidth = 200;
    @Input() componentWidthStretch = false;
    calculatedComponentWidth: number;

    @Input() prefixIcon = true;
    @Input() rowNumber = 1;
    @Input() height = 55;
    @Input() centeredText = false;
    @Input() isBig = false;

    // Output can pass any type of data.
    @Input() selectDataKey = 'name';
    @Input() displayNameKey = 'tName';
    @Input() altNameKey = 'altName';
    @Input() tournamentSportEventCount = 'tournamentSportEventCount';
    @Input() sportEventCount = 'sportEventCount';

    @Input() isTranslated = false;
    @Input() dropdownType = '';

    @Input() _selectedItem;
    @Output() selectedItem: EventEmitter<any> = new EventEmitter();

    SPORTS_TYPE: Array<any> = SPORTS_TYPE();
    s;
    selectedIndex = 0;
    subsidleResetListener;

    constructor(
        public _TournamentsService: TournamentsService,
        public _translate: translationHelper,
        public _uiHelper: uiHelper,
        private renderer: Renderer2,
    ) {
        this.subsidleResetListener = this._uiHelper.idleResetListener.subscribe(s => {
            if (this._DATA != undefined && this._DATA[0] != undefined) this.handleClick(this._DATA[0], 0);
        });

        sportsTypesChangeListener.subscribe(item => (this.SPORTS_TYPE = item));
    }

    handleClick(e, index) {
        //console.log('--handleClick--E', e);
        // EnumSportType
        setTimeout(() => {
            this.isOpen = false;
        });
        this._selectedItem = e;
        this.selectedItem.emit({ key: e[this.selectDataKey], item: e });
        this.selectedIndex = index;
    }

    handleOpen(e) {
        if (this._DATA.length > 1) {
            if (e) {
                this.isOpen = !this.isOpen;
            } else {
                this.isOpen = e;
            }
        }
    }

    getSportCount(name: string): string {
        if (this.dropdownType === 'sportCategory' || this.dropdownType === 'leagueCategory') {
            return '';
        }
        try {
            let count = this.SPORTS_TYPE.filter(i => name == i.name)[0][this.sportEventCount];
            return count == '0' ? '' : count;
        } catch (e) {
            return '';
        }
    }

    ngOnInit(): void {
        this.calculatedComponentWidth = this.componentWidth * this.rowNumber + this.rowNumber * 2;
        // console.log('this.calculatedComponentWidth', this.calculatedComponentWidth);
    }

    ngAfterViewInit() {}

    ngOnChanges(simpleC: SimpleChanges) {
        // console.log('dataaaa', this._DATA);
        // console.log("-----this.calculatedComponentWidth-------------",this.calculatedComponentWidth);
        if (simpleC._DATA && simpleC._DATA.currentValue && simpleC._DATA.previousValue) {
            // console.log('changee');
            this._selectedItem = this._DATA[0];
            // console.log({ key: this._selectedItem[this.selectDataKey], item: this._selectedItem });

            // console.log('SELECTEDDD', this._selectedItem);
            if (this._selectedItem != undefined) {
                this.selectedItem.emit({ key: this._selectedItem[this.selectDataKey], item: this._selectedItem });
            }
        }

        if (typeof this._selectedItem === 'undefined' && typeof this._DATA !== 'undefined') {
            this._selectedItem = this._DATA[0];
        }
    }

    ngOnDestroy() {
        if (this.subsidleResetListener != undefined) {
            this.subsidleResetListener.unsubscribe();
            this.subsidleResetListener = undefined;
        }
    }
}
